import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { useStore } from 'lib/store';
import { useApiReady } from './use-api-ready';

type Params = {
  listingId: string;
};

export function useListingAnalytics({ listingId }: Params) {
  const apiReady = useApiReady();
  const activeBuyerOrgId = useStore((store) => store.activeBuyerOrgId);

  return useQuery(
    ['listing-analytics', listingId],
    () =>
      new ApiClient().listingApi.orgMarketplaceListingAnalyticsList({
        buyerOrgId: activeBuyerOrgId || '',
        listingId: listingId as string,
      }),
    {
      select: (data) => data.data,
      enabled: apiReady && !!activeBuyerOrgId && !!listingId,
      retry: 0,
      staleTime: 5 * (60 * 1000),
      cacheTime: 10 * (60 * 1000),
    }
  );
}
